export default __webpack_public_path__ + "static/media/car-5.5c314f67.png";